module.exports = __webpack_public_path__ + "static/media/text box.a93701b4.jpg";